import { render, staticRenderFns } from "./PayByCheck.vue?vue&type=template&id=ebd33c2a&scoped=true&"
import script from "./PayByCheck.vue?vue&type=script&lang=js&"
export * from "./PayByCheck.vue?vue&type=script&lang=js&"
import style0 from "./PayByCheck.vue?vue&type=style&index=0&id=ebd33c2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd33c2a",
  null
  
)

export default component.exports